import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { DataStoreService } from './core/services/Data-Store/data-store.service';
import { AuthService } from './sso/service/auth.service';
import { IdleTimerService } from './sso/service/idle-timer.service';
import { ssoConfig } from './sso/sso.config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'satsang-org-UI';
  showFooter: boolean = true;
  notShowFooterFor: string[] = ['/home/publications', '/home/kendra-mandir'];
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    public dataStoreService: DataStoreService,
    private authService: AuthService,
    private idleTimerService: IdleTimerService
  ) {}

  ngOnInit(): void {
    // Hiding footers for the pages mentioned in notShowFooterFor array
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: any) => {
        const snapshot: RouterStateSnapshot = this.router.routerState.snapshot;
        // For updating the currently active url
        this.dataStoreService.updateCurrentlyActiveURL(snapshot.url);
        this.showFooter = !this.notShowFooterFor.includes(snapshot.url);
        if (snapshot.url.startsWith('/home/publications'))
          this.showFooter = false;
        this.dataStoreService.updateFooterInCurrentPage(this.showFooter);
      });
    if (localStorage.getItem('token')) {
      this.authService.initTimer();
      this.idleTimerService.startWatching(() => {
        console.log('Logging out due to inactivity...');
        this.authService.logOut(false);
      });
    }

    this.authService.tokenExpiresInSecond.subscribe((value: number) => {
      console.log('COUNT DOWN: ', value);
      if (value && value <= 0) {
        this.authService.logOut(false);
      }
      if (value && value <= ssoConfig.timeBeforeCallingRefreshInSecs && !this.authService.isRefreskTokenApiCalled) {
        console.log('REFRESH MEE');
        this.authService.renewAccessToken();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
